import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { tagName } from '../../helpers/element.helper';

const tag = tagName('marker');

@customElement(tag)
export class MarkerComponent extends TmElement {
  static override styles = [
    css`
      :where(.marker) {
        font-variant-numeric: tabular-nums;
      }
    `,
  ];

  override render() {
    return html`<span class="marker"><slot></slot></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-marker': MarkerComponent;
  }
}
